import { Domain } from "src/config/BartLambdaConfig";

const ORCA_WF_LINK_PREFIX: { [domain: string]: string } = {
  "devo-FE":
    "https://beta.us-west-2.studio.orca.amazon.dev/#/clients/fuse-billing/executions/",
  "prod-FE":
    "https://us-west-2.studio.orca.amazon.dev/#/clients/fuse-billing/executions/",
  "prod-EU":
    "https://eu-south-2.studio.orca.amazon.dev/#/clients/fuse-billing/executions/",
  "prod-US":
    "https://us-east-1.studio.orca.amazon.dev/#/clients/fuse-billing/executions/",
};

export const getTransactionWfLink = (externalId: string, domain: Domain) =>
  `${ORCA_WF_LINK_PREFIX[domain]}FuseTransaction:${externalId}`;

export const getFusenWfLink = (externalId: string, domain: Domain) =>
  `${ORCA_WF_LINK_PREFIX[domain]}FUSEN:${externalId}`;

const ACID_LINK_PREFIX: { [domain: string]: string } = {
  "devo-FE": "https://axon-ops.integ.amazon.com/acid/report?AGGREGATION_KEY=",
  "prod-FE": "https://axon-ops-fe.aka.amazon.com/acid/report?AGGREGATION_KEY=",
  "prod-EU": "https://axon-ops-eu.aka.amazon.com/acid/report?AGGREGATION_KEY=",
  "prod-US": "https://axon-ops-na.aka.amazon.com/acid/report?AGGREGATION_KEY=",
};

export const getAcidLink = (externalId: string, domain: Domain) =>
  `${ACID_LINK_PREFIX[domain]}${externalId}`;

const FLASH_LINK_PREFIX: { [domain: string]: { [test: string]: string } } = {
  "devo-FE": {
    true: "https://flashui-beta-na.integ.amazon.com/search/transaction?transactionId=",
    false:
      "https://flashui-beta-na.integ.amazon.com/search/transaction?transactionId=",
  },
  "prod-FE": {
    true: "https://flashui-gamma-fe.aka.amazon.com/search/transaction?transactionId=",
    false:
      "https://flashui-fe.aka.amazon.com/search/transaction?transactionId=",
  },
  "prod-EU": {
    true: "https://flashui-gamma-eu.aka.amazon.com/search/transaction?transactionId=",
    false:
      "https://flashui-eu.aka.amazon.com/search/transaction?transactionId=",
  },
  "prod-US": {
    true: "https://flashui-gamma-na.aka.amazon.com/search/transaction?transactionId=",
    false:
      "https://flashui-na.aka.amazon.com/search/transaction?transactionId=",
  },
};

const FLASH_LINK_POSTFIX: { [domain: string]: { [test: string]: string } } = {
  "devo-FE": {
    true: "&realm=JPAmazon&domain=test",
    false: "&realm=JPAmazon&domain=test",
  },
  "prod-FE": {
    true: "&realm=JPAmazon&domain=uat",
    false: "&realm=JPAmazon&domain=prod",
  },
  "prod-EU": {
    true: "&realm=EUAmazon&domain=uat",
    false: "&realm=EUAmazon&domain=prod",
  },
  "prod-US": {
    true: "&realm=USAmazon&domain=uat",
    false: "&realm=USAmazon&domain=prod",
  },
};

export const getFlashLink = (uslId: string, domain: Domain, test: boolean) => {
  const testString = test ? "true" : "false";
  return `${FLASH_LINK_PREFIX[domain][testString]}${uslId}${FLASH_LINK_POSTFIX[domain][testString]}`;
};
